import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Footer from "./components/Footer";
import Content from "./components/Content";
import ImpressumDe from "./pages/ImpressumDe";
import DatenschutzDe from "./pages/DatenschutzDe";
import { detectDeviceType } from "./utils/deviceDetection";
import "./App.css";
import { ConsentProvider } from "./context/ConsentContext";
import CookieConsentManager from "./components/CookieConsentManager";

const App = () => {
  const [locale, setLocale] = useState("de");
  const [deviceType, setDeviceType] = useState("Web");

  useEffect(() => {
    const savedLocale =
      localStorage.getItem("locale") || navigator.language.slice(0, 2);
    setLocale(savedLocale === "de" ? "de" : "en");
    setDeviceType(detectDeviceType());
  }, []);

  return (
    <Router>
      <ConsentProvider>
        <div className="App">
          <Routes>
            <Route
              path="/"
              element={<Content locale={"de"} deviceType={deviceType} />}
            />
            <Route path="/impressum" element={<ImpressumDe />} />
            <Route path="/datenschutz" element={<DatenschutzDe />} />
          </Routes>
          <Footer locale={locale} deviceType={deviceType} />

          <CookieConsentManager />
        </div>
      </ConsentProvider>
    </Router>
  );
};

export default App;
